import { render, staticRenderFns } from "./CockpitActiveOrderDetailsTab.vue?vue&type=template&id=38dfc1aa&scoped=true"
import script from "./CockpitActiveOrderDetailsTab.vue?vue&type=script&lang=js"
export * from "./CockpitActiveOrderDetailsTab.vue?vue&type=script&lang=js"
import style0 from "./CockpitActiveOrderDetailsTab.vue?vue&type=style&index=0&id=38dfc1aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dfc1aa",
  null
  
)

export default component.exports